<template>
  <div>
    <!-- <div class="grid grid-cols-3 gap-4 mt-6">
      <el-card class="elcard-p0px rounded-10px">
        <div class="flex items-center py-2">
          <div
            class="bg-f4f5f6 text-center bor-baju border-none text-8f8f8f p-2 w-1/3"
          >
            <p class="fsize10 font-normal text-8f8f8f">October</p>
            <h1 class="font-bold text-primary mb-0 text-2xl">24</h1>
            <p class="fsize10 font-normal text-8f8f8f">Monday</p>
          </div>
          <div class="items-center w-8/12 pl-2">
            <div>
              <small class="fsize10 font-semibold col-4f"
                >Festival Holiday</small
              >
              <h1 class="font-semibold text-dark mb-0 fsize14">
                World Health Day
              </h1>
              <small class="fsize10 font-medium text-8f8f8f">Industry</small>
            </div>
          </div>
        </div>
        <div>
          <div
            class="p-4"
            :style="{
              background: brandProfile.primaryColor
                ? brandProfile.primaryColor
                : '#f4f5f6',
            }"
          >
            <div class="flex items-center mb-2">
              <img :src="getImage" class="w-12 rounded-md" alt="logo" />
            </div>
            <h2
              class="font-semibold flex justify-between items-center text-white fsize16"
            >
              Primary card title
              <feather-icon
                @click="updatePopupDetails(item)"
                icon="EditIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
              />
            </h2>
            <p class="mt-2 mb-4 font-medium fsize12 text-white lineclamp-2">
              Create a custom video greeting to represent your brand.
            </p>

            <img
              :src="
                layout.img
                  ? layout.img
                  : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/imageLayouts/1.png'
              "
              alt="image"
              class="w-full h-130px"
            />
          </div>

          <div class="grid grid-cols-2 p-4 justify-end gap-2">
            <vs-button type="border" color="primary" class="sm-button w-full"
              >Edit</vs-button
            >

            <vs-button color="warning" class="sm-button w-full"
              >Design Post</vs-button
            >
          </div>
        </div>
      </el-card>
    </div> -->
    <div class="grid grid-cols-3 gap-4 mt-6">
      <el-card
        class="elcard-p0px rounded-10px"
        v-for="(item, index) in events"
        :key="'index-' + index"
      >
        <div class="flex items-center py-2">
          <div
            class="bg-f4f5f6 text-center bor-baju border-none text-8f8f8f p-2 w-1/3"
          >
            <p class="fsize10 font-normal text-8f8f8f">
              {{ month[new Date(item.eventDate).getMonth()] }}
            </p>
            <h1 class="font-bold text-primary mb-0 text-2xl">
              {{ new Date(item.eventDate).getDate() }}
            </h1>
            <p class="fsize10 font-normal text-8f8f8f">
              {{ day[new Date(item.eventDate).getDay()] }}
            </p>
          </div>
          <div class="items-center w-8/12 px-2">
            <div>
              <small class="fsize10 font-semibold col-4f"
                >Festival Holiday</small
              >
              <h1 class="font-semibold text-dark mb-0 fsize14 lineclamp-2">
                {{ item.eventTitle }}
              </h1>
              <small class="fsize10 font-medium text-8f8f8f">Industry</small>
            </div>
          </div>
        </div>

        <div class="img_wrap">
          <div v-if="Posts[index]">
            <img
              :src="
                Posts[index]
                  ? Posts[index]
                  : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/imageLayouts/1.png'
              "
              alt="image"
              class="w-full object-cover"
            />
          </div>
          <div v-else class="flex">
            <div
              class="p-4 grid"
              :style="{
                background: item.isLayout
                  ? brandProfile.primaryColor
                  : '#f4f5f6',
              }"
            >
              <div>
                <div class="flex items-center mb-2">
                  <img :src="getImage" class="w-12 rounded-md" alt="logo" />
                </div>
                <div class="flex justify-between items-center">
                  <h2
                    :style="{
                      color: item.isLayout ? '#fff' : '#000',
                    }"
                    class="font-semibold fsize16 lineclamp-1"
                  >
                    {{ item.subtitle }}
                  </h2>
                  <!-- <feather-icon
                    @click="updatePopupDetails(item)"
                    icon="EditIcon"
                    svgClasses="w-4 h-4"
                    class="cursor-pointer"
                  /> -->
                </div>
              </div>
              <p
                :style="{
                  color: item.isLayout ? '#fff' : '#000',
                }"
                class="mt-2 mb-2 font-medium fsize12 lineclamp-1"
              >
                {{ item.caption }}
              </p>

              <!-- <div class="relative cursor-pointer">
            <img
              :src="
                layoutImageSource
                  ? layoutImageSource
                  : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/projects/branding/imageLayouts/1.png/assets/hello.png'
              "
              class="rounded-full w-16 h-16"
            />

            <div class="absolute bottom-0 right-0">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/projects/branding/imageLayouts/1.png/assets/up.png"
                alt="image"
                class=""
              />
            </div>
            <input
              type="file"
              ref="fileInput1"
              @change="uploadFile"
              class="choosefilelogo"
            />
          </div> -->

              <img
                :src="
                  layout.img
                    ? layout.img
                    : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/imageLayouts/1.png'
                "
                alt="image"
                class="w-full h-130px"
              />
            </div>
          </div>
        </div>
        <div v-if="Posts[index]">
          <div class="grid grid-cols-2 p-4 justify-end gap-2">
            <vs-button
              type="border"
              @click="updatePopupDetails(index)"
              class="sm-button w-full"
              >Edit</vs-button
            >

            <vs-button
              color="success"
              class="bg-success sm-button w-full"
              @click="shareImage(Posts[index])"
              >Download</vs-button
            >
          </div>
        </div>
        <div v-else class="p-5">
          <vs-button
            type="border"
            @click="updatePopupDetails(index)"
            class="sm-button w-full"
            >Create Post</vs-button
          >
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";
export default {
  props: {
    layout: {
      type: String,
      default: "",
    },
    events: {
      type: Array,
      default: [],
    },
    Posts: {
      type: Array,
      default: [],
    },
    // layout: {
    //   img: { type: String },
    //   id: { type: String },
    //   default: "",
    // },
  },
  data() {
    return {
      eventsCard: [],
      month: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
      day: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      isShowContentEdit: false,
      description: "",
      title: "",
      layoutImageSource: "",
      isShowImage: "",
    };
  },

  computed: {
    ...mapState("brandProfile", ["brandProfile", "layoutSelected"]),
    getImage() {
      return this.brandProfile.primaryLogo
        ? `${this.$imageURL}/${this.brandProfile.primaryLogo}`
        : "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/marcom/icecream.png";
    },
  },

  watch: {
    layoutSelected() {
      this.setLayout();
    },
  },
  async mounted() {
    await this.setLayout();
    console.log(this.Posts, "INSIDE");

    // await this.getBrandingImage();
  },
  methods: {
    shareImage(url) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = "posts.jpg";

          downloadLink.click();
          URL.revokeObjectURL(downloadLink.href);
          downloadLink.remove();
        })
        .catch((error) => {
          console.error("Error downlaoding file:", error);
        });
    },
    updatePopupDetails(index) {
      this.$emit("isShowUpdate", index);
      this.$emit("Platformname", "Whatsapp");
    },

    setLayout(index) {
      console.log();
      // for (let index = 0; index < this.eventsCard.length; index++) {
      if (index < 9) {
        return this.layoutSelected.layout.includes(index);
      } else {
        const layout = index % 9;
        return this.layoutSelected.layout.includes(layout);
      }
      // }
    },

    updateDetails() {
      this.isShowContentEdit = false;
    },

    async getBrandingImage() {
      const { data } = await axios.post(
        `${process.env.VUE_APP_BRANDING_API}api/v1/postSingle`,
        {
          fontFamily: ["Montserrat"],
          brandName: "brained",
          textsmall: "husien",
          textBig: "merrin",
          patternColor: "blue",
        }
      );
      console.log(data, "IMAGE");
    },
  },
};
</script>
